import { NgClass } from "@angular/common";
import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { IconComponent } from "@components/icon/icon.component";
import { VirkeskopAffarsformer } from "~app/common/models/constants";
import { KontraktDTO } from "~app/common/models/virkeskop/VirkeskopKontraktAvtalSaveDTO";
import { KontraktDrivningspunkterValidationService } from "./kontrakt-drivningspunkter-validation.service";
import { KontraktDrivningspunkterValidationTexts } from "./kontrakt-drivningspunkter-validation.texts";

@Component({
    selector: "rask-kontrakt-drivningspunkter-validation",
    templateUrl: "./kontrakt-drivningspunkter-validation.component.html",
    styleUrls: ["./kontrakt-drivningspunkter-validation.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        IconComponent,
        NgClass
    ]
})
export class KontraktDrivningspunkterValidationComponent {
    @Input() kontrakt: KontraktDTO;
    texts = KontraktDrivningspunkterValidationTexts.texts;

    private readonly kontraktDrivningspunkterValidationService = inject(KontraktDrivningspunkterValidationService);

    allValid = () => this.kontraktDrivningspunkterValidationService.allValid(this.kontrakt);

    isAvlaggValid = () => this.kontraktDrivningspunkterValidationService.isKontraktAvlaggValid(this.kontrakt);

    isKojplatsValid = () => this.kontraktDrivningspunkterValidationService.isKontraktKojplatsValid(this.kontrakt);

    isLarmkoordinatValid = () => this.kontraktDrivningspunkterValidationService.isKontraktLarmkoordinatValid(this.kontrakt);

    showIcon(): boolean {
        return (!this.kontrakt ||
            this.kontrakt.affarsform === VirkeskopAffarsformer.Rotpost || // U2
            this.kontrakt.affarsform === VirkeskopAffarsformer.AuFastKostnad || // U4
            this.kontrakt.affarsform === VirkeskopAffarsformer.AuSjalvkostnad || // U5
            this.kontrakt.affarsform === VirkeskopAffarsformer.Leveransrotkop); // U6
    }
}
